module.exports = "<p>\n  root works!\n</p>\n"